<template>
  <div>
    <p>{{ $t("pages.Auth.Callback.SigninProgress") }}</p>
  </div>
</template>

<script>
export default {
  async created() {
    try {
      const result = await this.$GAUserAuth.signinCallback();
      let returnToUrl = '/';
      if (result.state !== undefined) {
        returnToUrl = result.state;
      }
      this.$router.push({ path: returnToUrl });
    } catch (e) {
      // console.log("Error", e);
      this.$router.push({ name: 'Unauthorized' });
    }
  },
};
</script>
